<cui-side-sheet>
  <cui-side-sheet-header (close)="closeFilter()">
    Filters
  </cui-side-sheet-header>
  <cui-side-sheet-content
    data-pgr-id="filters"
    aria-relevant="text"
    class="has-header"
  >
    <div class="flex items-center justify-between pb-s">
      <button
        mat-stroked-button
        color="primary"
        (click)="resetFilters()"
        data-pgr-id="btnResetFilters"
        class="ml-auto"
      >
        Reset
      </button>
    </div>
    @if (paymentsFilters$ | async; as vm) {
    <cui-accordion multi="true" data-pgr-id="paymentsFilters">
      @for (column of vm.columns; track trackById($index, column)) { @if
      (showFilterPanel(vm.filters[column.id])) {
      <cui-accordion-item [attr.data-pgr-id]="column.title + ' Filter Panel'">
        <cui-accordion-header>
          <mat-panel-title>
            <p
              class="expansion-title"
              [matBadge]="getFilterCount(vm.filters[column.id])"
              [matBadgeHidden]="filterCountIsHidden(vm.filters[column.id])"
              [matBadgeOverlap]="false"
              matBadgeSize="small"
              [attr.aria-label]="
                column.title +
                ' ' +
                getFilterCount(vm.filters[column.id]) +
                ' active'
              "
            >
              {{ column.title }}
            </p>
          </mat-panel-title>
        </cui-accordion-header>
        <cui-accordion-body>
          @if ( vm.filters[column.id].filterOptions &&
          vm.filters[column.id].filterType == 'Select' ) {
          <mat-checkbox
            [disabled]="!vm.filters[column.id].appliedFilters.length"
            [checked]="!vm.filters[column.id].appliedFilters.length"
            (change)="resetColumnFilters(column.id)"
            [attr.data-pgr-id]="column.title + ' Checkbox-All'"
          >
            All <strong>({{ vm.filters[column.id].scopedTotal }})</strong>
          </mat-checkbox>
          @for ( filterOption of vm.filters[column.id].filterOptions; track
          trackByText(i, filterOption); let i = $index) {
          <mat-checkbox
            [checked]="
              vm.filters[column.id].appliedFilters.indexOf(
                filterOption.filterText
              ) !== -1
            "
            (change)="onToggleFilter(column.id, filterOption)"
            [attr.data-pgr-id]="column.title + ' Checkbox-' + i"
            class="block"
          >
            <span [class]="filterOption.count ? '' : 'color-gray'"
              >{{ filterOption.filterDisplayText }}
              <strong>({{ filterOption.count }})</strong>
            </span>
          </mat-checkbox>
          } } @if ( vm.filters[column.id].filterOptions &&
          vm.filters[column.id].filterType == 'NumberRange' ) {
          <mat-form-field class="ml-bl-1 mb-xs" appearance="outline">
            <mat-label>Minimum</mat-label>
            <input
              matInput
              cuiCurrencyFormatter
              [formControl]="numberRangeMin[column.id]"
              [allowNegative]="true"
              (blur)="updateMinNumberRange($event, column.id)"
              (keydown.enter)="updateMinNumberRange($event, column.id)"
            />
            <mat-error [hidden]="numberRangeMin[column.id].valid">
              Please enter a number.
            </mat-error>
          </mat-form-field>
          <mat-form-field class="ml-bl-1" appearance="outline">
            <mat-label>Maximum</mat-label>
            <input
              matInput
              cuiCurrencyFormatter
              [formControl]="numberRangeMax[column.id]"
              [allowNegative]="true"
              (blur)="updateMaxNumberRange($event, column.id)"
              (keydown.enter)="updateMaxNumberRange($event, column.id)"
            />
            <mat-error [hidden]="numberRangeMax[column.id].valid">
              Please enter a number.
            </mat-error>
          </mat-form-field>
          }
        </cui-accordion-body>
      </cui-accordion-item>
      } }
    </cui-accordion>
    }
  </cui-side-sheet-content>
</cui-side-sheet>
